<template>
  <div style="width: calc(100% - 70px); height: calc(100% - 20px)">
    <div style="height: 100%">
      <Templates
        :containerHeight="'calc(100% - 20px) !important'"
        :selectMode="true"
        :dense="true"
        @selected="selectTemplates" />
    </div>
  </div>
</template>
<script setup>
import { onMounted, defineProps, defineAsyncComponent } from 'vue';

// Use dynamic import to avoid bundling Templates into main chunk
const Templates = defineAsyncComponent(
  () => import('../../Templates/Templates.vue')
);

const props = defineProps([
  'customState',
  'userEditObj',
  'qid',
  'channel_did',
  'containerHeight',
]);

function selectTemplates(newVal) {
  props.customState.template_ids = newVal;
}

onMounted(() => {
  console.log('mounted tab 2: Create Scene From Templates');
});
</script>

<style scoped></style>
